<template>
    <UModal v-model:open="isInviteCodeModalOpen" :dismissible="false">
        <template #content>
            <div class="p-6 space-y-4">
                <div class="flex items-center justify-between mb-4">
                    <h3 class="text-lg font-semibold text-title">{{ $t('pages.login.inviteCodeModal.title') }}</h3>
                    <UButton color="neutral" variant="ghost" @click="isInviteCodeModalOpen = false"
                        :disabled="isLoading">
                        <UIcon name="i-lucide-x" class="w-4 h-4" />
                    </UButton>
                </div>
                <div class="flex flex-col mb-4 text-sm text-body">
                    <p>{{ $t('pages.login.inviteCodeModal.subtitle') }}</p>
                </div>
                <div>
                    <UForm :state="formState" :schema="schema" @submit="handleSubmit" class="space-y-4">
                        <UFormField name="inviteCode" :label="$t('pages.login.inviteCodeModal.label')">
                            <UInput class="w-full" v-model="formState.inviteCode" size="lg"
                                :placeholder="$t('pages.login.inviteCodeModal.placeholder')" />
                        </UFormField>
                    </UForm>
                </div>
                <div class="flex justify-end gap-2">
                    <UButton color="neutral" variant="outline" @click="isInviteCodeModalOpen = false"
                        :disabled="isLoading">
                        {{ $t('common.buttons.cancel') }}
                    </UButton>
                    <UButton color="primary" variant="solid" @click="handleSubmit" :loading="isLoading"
                        :disabled="isLoading">
                        {{ $t('common.buttons.confirm') }}
                    </UButton>
                </div>
            </div>
        </template>
    </UModal>
</template>
<script setup lang="ts">
import * as yup from 'yup';
import { useGoogleOAuth } from '~/composables/useGoogleOAuth';

const { t } = useI18n();
const { completeGuestSignup } = useGoogleOAuth();
const router = useRouter();
const isInviteCodeModalOpen = defineModel<boolean>('isInviteCodeModalOpen');
const isLoading = ref(false);
const formState = ref({
  inviteCode: '',
});
const schema = yup.object({
  inviteCode: yup.string().required(t('pages.login.inviteCodeModal.required')),
});

const handleSubmit = async () => {
  isLoading.value = true;
  try {
    // 失敗時留在 Modal 內，讓使用者修正邀請碼後重試
    await completeGuestSignup({
      guestUserUuid: router.currentRoute.value.query.guest_user_uuid as string,
      inviteCode: formState.value.inviteCode,
      onFailure: 'stay',
      fallbackErrorMessage: t('pages.login.inviteCodeModal.error'),
    });
  } finally {
    isLoading.value = false;
  }
};
</script>